export enum CallerIdentity {
  microsoftTeamsUser = 'microsoftTeamsUser',
  phoneNumber = 'phoneNumber',
  microsoftBot = 'microsoftBot',
  microsoftTeamsApp = 'microsoftTeamsApp',
  unknown = 'unknown',
}
